export default __webpack_public_path__ + "static/media/f-06.f58548bc.jpg";